var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#C13C3C;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#C13C3C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,36.5l15-26c0.8-1.3,2.7-1.3,3.5,0l15,26c0.8,1.3-0.2,3-1.7,3h-30C7.9,39.5,7,37.8,7.7,36.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.5,
    y1: 18.5,
    x2: 24.5,
    y2: 31.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 24.5,
    cy: 34.5,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/redAlert.351566f8167c86414f77c7a8b96ecfb6.svg";
export { ForwardRef as ReactComponent };